<script>

    import { toast } from 'bulma-toast'
    import { modalStore, notifyStore } from '../stores'

    import FixedpricesService from '../$services/fixedprices.service'

    import ButtonSave from '../$components/button.save.svelte'
    import Switch from '../$components/switch.svelte'
    import Form from '../$components/form.svelte'
    import File from '../$components/file.svelte'

    let data = {}
    let loading = false

    async function uploadFixedprices() {

        loading = true
        const resp = await FixedpricesService.uploadFixedprices(data)
        loading = false

        if(!resp.success)
            return toast({message: resp.error.message, type: 'is-danger'})

        toast({message: `Precios cargados`, type: 'is-success'})

        notifyStore.set('fixedprices_updated')
        modalStore.close()
    }

</script>

<Form on:submit={uploadFixedprices} { loading } >

    <File bind:file={data.fixedpricesFile} />
    <br>

    <Switch bind:checked={data.deleteFixedprices} label="Borrar precios actuales" />

    <div class="is-flex is-justify-content-space-between is-align-items-center">
        <a href="/files/fixedprices_template.csv" download="fixedprices_template.csv">Descargar plantilla</a>
        <ButtonSave { loading } />
    </div>

</Form>